// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=none"
// @generated from file puzzle.proto (package crossme, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file puzzle.proto.
 */
export const file_puzzle: GenFile = /*@__PURE__*/
  fileDesc("CgxwdXp6bGUucHJvdG8SB2Nyb3NzbWUi/wMKBlB1enpsZRINCgV0aXRsZRgBIAEoCRIOCgZhdXRob3IYAiABKAkSEQoJY29weXJpZ2h0GAMgASgJEgwKBG5vdGUYBCABKAkSDQoFd2lkdGgYBSABKAUSDgoGaGVpZ2h0GAYgASgFEiUKB3NxdWFyZXMYCCADKAsyFC5jcm9zc21lLlB1enpsZS5DZWxsEioKDGFjcm9zc19jbHVlcxgJIAMoCzIULmNyb3NzbWUuUHV6emxlLkNsdWUSKAoKZG93bl9jbHVlcxgKIAMoCzIULmNyb3NzbWUuUHV6emxlLkNsdWUSJgoIbWV0YWRhdGEYCyABKAsyFC5jcm9zc21lLlB1enpsZS5NZXRhGmwKBENlbGwSDgoGbnVtYmVyGAEgASgFEg0KBWJsYWNrGAIgASgIEg8KB2NpcmNsZWQYAyABKAgSDAoEZmlsbBgEIAEoCRITCgtjbHVlX2Fjcm9zcxgFIAEoBRIRCgljbHVlX2Rvd24YBiABKAUaJAoEQ2x1ZRIOCgZudW1iZXIYASABKAUSDAoEdGV4dBgDIAEoCRpdCgRNZXRhEisKB2NyZWF0ZWQYASABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEg4KBnNoYTI1NhgCIAEoCRIKCgJpZBgFIAEoCRIMCgRkYXRlGAMgASgJIuYBCgtQdXp6bGVJbmRleBIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIMCgRkYXRlGAMgASgJEg4KBmF1dGhvchgEIAEoCRInCgRnYW1lGAUgASgLMhkuY3Jvc3NtZS5QdXp6bGVJbmRleC5HYW1lGnUKBEdhbWUSCgoCaWQYASABKAkSLwoLbGFzdF9wbGF5ZWQYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjAKDGNvbXBsZXRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBCFFoSY3Jvc3NtZS5hcHAvc3JjL3BiYgZwcm90bzM", [file_google_protobuf_timestamp]);

/**
 * @generated from message crossme.Puzzle
 */
export type Puzzle = Message<"crossme.Puzzle"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string author = 2;
   */
  author: string;

  /**
   * @generated from field: string copyright = 3;
   */
  copyright: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * @generated from field: int32 width = 5;
   */
  width: number;

  /**
   * @generated from field: int32 height = 6;
   */
  height: number;

  /**
   * @generated from field: repeated crossme.Puzzle.Cell squares = 8;
   */
  squares: Puzzle_Cell[];

  /**
   * @generated from field: repeated crossme.Puzzle.Clue across_clues = 9;
   */
  acrossClues: Puzzle_Clue[];

  /**
   * @generated from field: repeated crossme.Puzzle.Clue down_clues = 10;
   */
  downClues: Puzzle_Clue[];

  /**
   * @generated from field: crossme.Puzzle.Meta metadata = 11;
   */
  metadata?: Puzzle_Meta | undefined;
};

/**
 * Describes the message crossme.Puzzle.
 * Use `create(PuzzleSchema)` to create a new message.
 */
export const PuzzleSchema: GenMessage<Puzzle> = /*@__PURE__*/
  messageDesc(file_puzzle, 0);

/**
 * @generated from message crossme.Puzzle.Cell
 */
export type Puzzle_Cell = Message<"crossme.Puzzle.Cell"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: bool black = 2;
   */
  black: boolean;

  /**
   * @generated from field: bool circled = 3;
   */
  circled: boolean;

  /**
   * @generated from field: string fill = 4;
   */
  fill: string;

  /**
   * @generated from field: int32 clue_across = 5;
   */
  clueAcross: number;

  /**
   * @generated from field: int32 clue_down = 6;
   */
  clueDown: number;
};

/**
 * Describes the message crossme.Puzzle.Cell.
 * Use `create(Puzzle_CellSchema)` to create a new message.
 */
export const Puzzle_CellSchema: GenMessage<Puzzle_Cell> = /*@__PURE__*/
  messageDesc(file_puzzle, 0, 0);

/**
 * @generated from message crossme.Puzzle.Clue
 */
export type Puzzle_Clue = Message<"crossme.Puzzle.Clue"> & {
  /**
   * @generated from field: int32 number = 1;
   */
  number: number;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message crossme.Puzzle.Clue.
 * Use `create(Puzzle_ClueSchema)` to create a new message.
 */
export const Puzzle_ClueSchema: GenMessage<Puzzle_Clue> = /*@__PURE__*/
  messageDesc(file_puzzle, 0, 1);

/**
 * @generated from message crossme.Puzzle.Meta
 */
export type Puzzle_Meta = Message<"crossme.Puzzle.Meta"> & {
  /**
   * @generated from field: google.protobuf.Timestamp created = 1;
   */
  created?: Timestamp | undefined;

  /**
   * sha256 of the .puz file that imported to this puzzle, in
   * hex
   *
   * @generated from field: string sha256 = 2;
   */
  sha256: string;

  /**
   * Unique ID used to refer to this puzzle
   *
   * @generated from field: string id = 5;
   */
  id: string;

  /**
   * YYYY-MM-DD parsed date that the puzzle was published, or ""
   *
   * @generated from field: string date = 3;
   */
  date: string;
};

/**
 * Describes the message crossme.Puzzle.Meta.
 * Use `create(Puzzle_MetaSchema)` to create a new message.
 */
export const Puzzle_MetaSchema: GenMessage<Puzzle_Meta> = /*@__PURE__*/
  messageDesc(file_puzzle, 0, 2);

/**
 * @generated from message crossme.PuzzleIndex
 */
export type PuzzleIndex = Message<"crossme.PuzzleIndex"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string date = 3;
   */
  date: string;

  /**
   * @generated from field: string author = 4;
   */
  author: string;

  /**
   * The caller's own game of this puzzle, so the list can link back
   * to it. Unset for anonymous callers, and for puzzles the caller has
   * not played. A user who has played a puzzle more than once gets a
   * single game here: a solved one if there is one, otherwise the most
   * recently played.
   *
   * @generated from field: crossme.PuzzleIndex.Game game = 5;
   */
  game?: PuzzleIndex_Game | undefined;
};

/**
 * Describes the message crossme.PuzzleIndex.
 * Use `create(PuzzleIndexSchema)` to create a new message.
 */
export const PuzzleIndexSchema: GenMessage<PuzzleIndex> = /*@__PURE__*/
  messageDesc(file_puzzle, 1);

/**
 * @generated from message crossme.PuzzleIndex.Game
 */
export type PuzzleIndex_Game = Message<"crossme.PuzzleIndex.Game"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * When the caller last opened the game.
   *
   * @generated from field: google.protobuf.Timestamp last_played = 2;
   */
  lastPlayed?: Timestamp | undefined;

  /**
   * Set once the game has been solved; unset while in progress.
   *
   * @generated from field: google.protobuf.Timestamp completed_at = 3;
   */
  completedAt?: Timestamp | undefined;
};

/**
 * Describes the message crossme.PuzzleIndex.Game.
 * Use `create(PuzzleIndex_GameSchema)` to create a new message.
 */
export const PuzzleIndex_GameSchema: GenMessage<PuzzleIndex_Game> = /*@__PURE__*/
  messageDesc(file_puzzle, 1, 0);

